<template>
  <div>
    <v-data-table class="elevation-1" :headers="headers" :items="items" :loading="loading" :items-per-page="50"
                  show-expand
                  :options.sync="params.options" :server-items-length="params.total"
                  :footer-props="{showFirstLastPage: true, showCurrentPage: true, itemsPerPageOptions: [20, 50, 100]}"
                  @item-expanded="expandOrder">
      <template v-slot:top>
        <v-toolbar flat>
          <v-spacer/>
          <v-text-field class="search" append-icon="mdi-magnify" label="输入订单号进行搜索"
                        single-line hide-details clearable v-model="params.filters.search"
                        @click:append="getData" @click:clear="clear" @keydown.enter="getData"/>
          <v-btn icon @click="openFilterDialog">
            <v-icon>mdi-filter-menu</v-icon>
          </v-btn>
          <v-btn icon @click="getData">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider/>
      </template>
      <!-- 订单编号 -->
      <template v-slot:item.amazonOrderId="{ item }">
        {{ item.amazonOrderId }}
        <br/>
        <v-icon v-if="item.isPremiumOrder" color="#f79400">mdi-amazon</v-icon>
      </template>
      <!-- 订单状态 -->
      <template v-slot:item.orderStatus="{ item }">
        <span :class="getStatusColor(item.orderStatus)">{{ item.orderStatus }}</span>
      </template>
      <!-- 订单商品数量 -->
      <template v-slot:item.numberOfItemsShipped="{ item }">
        {{ item.numberOfItemsShipped + item.numberOfItemsUnshipped }}
      </template>
      <!-- 订单单价 -->
      <template v-slot:item.unitPrice="{ item }">
        <label>{{ item.orderTotal | div(item.numberOfItemsShipped + item.numberOfItemsUnshipped) }}</label>
      </template>
      <!-- 购买时间 -->
      <template v-slot:item.purchaseDate="{ item }">
        {{ item.purchaseDate | dateFormat }}
      </template>
      <!-- 商品信息列表 -->
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="grey lighten-2">
          <v-simple-table dense class="mx-auto" v-if="item.hasSetItems">
            <template v-slot:default>
              <thead>
              <tr>
                <th v-for="header of orderItemHeaders" :key="header" class="text-center">{{ header }}</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="orderItem in item.orderItems" :key="orderItem.id" class="text-center">
                <td>{{ orderItem.id }}</td>
                <td><img alt="商品主图" :src="orderItem.productImageUrl" height="80" width="80"/></td>
                <td>
                  <v-btn link text :href="orderItem.marketUrl + '/dp/' + orderItem.asin" target="_blank"
                         color="primary">{{ orderItem.asin }}
                  </v-btn>
                  <div>{{ orderItem.sellerSku }}</div>
                </td>
                <td>{{ orderItem.quantityOrdered }}</td>
                <!--<td>{{ orderItem.itemPrice }}</td>-->
              </tr>
              </tbody>
            </template>
          </v-simple-table>
          <template v-else>
            暂时未拉取到数据...
          </template>
        </td>
      </template>
    </v-data-table>
    <today-filter date-range item-count status :visible.sync="filterDialog" :params="params" @reload="getData"/>
  </div>
</template>
<script>
import TodayFilter from "@/page/Today/TodayFilter";

export default {
  name: "Orders",
  components: {TodayFilter},
  data() {
    return {
      loading: true,
      headers: [
        {text: "店铺", align: "center", value: "storeName"},
        {text: "订单编号", align: "center", value: "amazonOrderId"},
        {text: "状态", align: "center", value: "orderStatus"},
        {text: "商品数量", align: "center", value: "numberOfItemsShipped"},
        { text: "净销售额", align: "center", value: "orderTotal" },
        // { text: "单价", align: "center", value: "unitPrice" },
        {text: "下单时间", align: "center", value: "purchaseDate"},
        {text: '', value: 'data-table-expand'}
      ],
      orderItemHeaders: ["ID", "图片", "SKU", "数量"],
      items: [],
      params: {
        options: {
          sortBy: ["purchaseDate"],
          sortDesc: [true]
        },
        filters: {
          search: null,
          marketplaces: [],
          stores: [],
          asins: [],
          skus: [],
          statuses: [],
          minOrderItemCount: null,
          maxOrderItemCount: null,
          startPurchaseTime: null,
          endPurchaseTime: null
        },
        total: null
      },
      filterDialog: false,
      marketplaces: [],
      stores: [],
      asins: [],
      skus: [],
    }
  },
  methods: {
    getData() {
      this.items = [];
      this.loading = true;
      this.$axios.post("/orders", this.params).then(
          response => {
            this.items = response.data.list;
            this.params.total = response.data.total;
            this.loading = false;
            console.debug("查询到的订单: ", this.items);
          }
      );
    },
    clear() {
      setTimeout(function () {
        this.getData();
      }.bind(this), 300);
    },
    openFilterDialog() {
      this.filterDialog = true;
    },
    expandOrder(order) {
      // 如果处于打开状态, 并且该订单为初始化订单商品信息, 则从服务器上拉取数据
      console.log("展示了订单.", order);
      if (order.value && !order.item.orderItems) {
        console.log("请求订单数据");
        this.$axios.get(`/order/${order.item.id}/items`).then(
            response => {
              if (response.data) {
                console.debug("获得订单商品: ", response.data);
                this.$set(order.item, "orderItems", response.data);
              }
            }
        );
      }
    },
    getStatusColor(status) {
      switch (status) {
        case "Pending":
          return "primary--text";
        case "Shipped":
          return "success--text font-weight-bold";
        case "Canceled":
          return "error--text font-weight-bold";
        default:
          return "warning--text";
      }
    }
  }, watch: {
    "params.options": {
      deep: true,
      handler() {
        console.log("这次的options是: " + JSON.stringify(this.params.options));
        this.items = [];
        this.getData();
      }
    }
  }
}
</script>

<style scoped>
</style>